package com.platforma.chat_domain

import com.platforma.chat_domain.model.TableMessageDomain
import com.platforma.chat_domain.use_case.message.NetworkMessageUseCase
import com.platforma.chat_domain.use_case.message.TableMessageUseCase

data class MessagesUseCase(
    val table: TableMessageUseCase,
    val network: NetworkMessageUseCase
)
